<mat-list-item>
    <button mat-menu-item>
        <mat-icon>
            <div class="marker-item-icon" [style]="backgroundStyle"></div>
        </mat-icon>
        <span>{{marker.name | translateMarker:marker.markerType}}</span>
    </button>
</mat-list-item>
